import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { UserI } from '../../../interfaces/users/user.interface';
import { MessageService } from '../../../services/message.service';
import { UsersService } from '../../../services/users.service';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss']
})
export class UserProfileComponent implements OnInit {

  @Output() closeModal = new EventEmitter();
  @Input() userId: number;
  public loadingData = false;

  public userData: UserI;
  public recomendation: string;

  constructor(
    private userServ: UsersService,
    public messageServ: MessageService
  ) { }

  ngOnInit(): void {
    if (!this.userId) {
      this.messageServ.printStatus('No se recibio el id del usuario', 'warning');
      this.onClose();
      return;
    }
    this.loadUserData(this.userId);
  }

  loadUserData(user_id) {
    this.loadingData = true;

    this.userServ.showUsrData(user_id).subscribe(res => {
      if (res.ok === true) {
        this.loadingData = false;
        this.userData = res.user;

        this.userData.img =  (this.userData.img) ? `${environment.filestorage}/profile/${this.userData.img}` : 'assets/img/body-default.png';

        if (this.userData.last_recommendation) {
          this.recomendation = this.userData.last_recommendation;
        }
      }
    }, error => {
      this.loadingData = false;
      console.log(error);
      this.messageServ.printStatusArray(error.error.errors, 'error');
    });
  }

  saveRecomendation() {
    let _message;
    if (!this.recomendation) {
      _message = '¿Estás seguro de querer eliminar la recomendación?';
    }
    _message = '¿Estás seguro de querer guardar esta recomendación?';
    this.messageServ.confirmRequest(_message).then((data) => {
      if (data.value) {
        let data = {
          user_id: this.userData.id,
          recommendation: this.recomendation
        }
        this.userServ.saveRecomendation(data).subscribe(res => {
          if (res.ok === true) {
            this.messageServ.printStatus(res.message, 'success');
          }
        }, error => {
          console.log(error);
          this.messageServ.printStatusArray(error.error.errors, 'error');
        })
      }
    })
  }

  onClose() {
    this.closeModal.emit();
  }

}
